// hooks/useAction.ts
import { useState, useCallback } from "react";

/**
 * useAction é um hook genérico para requisições POST/PUT/DELETE.
 * @param serviceFn - função que faz a requisição e retorna uma Promise<T>.
 */
export function useAction<T>(serviceFn: (...args: any[]) => Promise<T>) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const execute = useCallback(
    async (...args: any[]) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await serviceFn(...args);
        setData(response);
        return response;
      } catch (err: any) {
        console.error("Erro na ação:", err);
        setError(err);
        throw err; // Repassa o erro pra quem chamou, se quiser usar try/catch fora
      } finally {
        setIsLoading(false);
      }
    },
    [serviceFn]
  );

  return { execute, isLoading, data, error, success, resetError, resetSuccess };
}
